import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import { Outlet } from "react-router-dom"
import FundFlowHeader from "./fund-flow/table/FundFlowHeader"

const FundFlowPage = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <FundFlowHeader />
        <Outlet />
      </CustomCard>
    </div>
  )
}

export default FundFlowPage
